"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_hooks_1 = require("@apollo/react-hooks");
const graphql_1 = require("../../graphql");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
exports.useDeleteIntegration = (id) => {
    const { history } = use_react_router_1.default();
    const [mutate] = react_hooks_1.useMutation(graphql_1.deleteIntegration, {
        onCompleted: () => {
            history.push('/integrations');
        },
        variables: {
            id,
        },
    });
    return { mutate };
};
//# sourceMappingURL=useDeleteIntegration.js.map